import React from 'react';
import AraForm from './components/AraForm';
import Header from './components/AraHeader';


function Home() {
    return (
        <React.Fragment>
            <Header />
            <AraForm />
        </React.Fragment>
    );
}

export default Home